import React from "react";
import { Box, Typography } from "@mui/material";
import SpinnerUmmIA from "../../Loading/SpinnerUmmIA";

interface Props {
  loading?: boolean;
  loadingText?: string;
  error?: string;
  empty?: boolean;
  emptyText?: string;
  size?: "sm" | "md";
}

const StatusLine: React.FC<Props> = ({
  loading,
  loadingText,
  error,
  empty,
  emptyText,
  size = "md",
}) => {
  const fontSize = size === "md" ? "0.82rem" : "0.78rem";
  const padding = size === "md" ? 1 : 0.8;

  if (loading) {
    return (
      <Box display="flex" alignItems="center" gap={1.2} p={padding}>
        <SpinnerUmmIA logoWidth={25} logoHeight = {25}/>
        <Typography sx={{ fontFamily: "Montserrat", fontSize }}>
          {loadingText}
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize,
          color: "#BA4534",
          fontWeight: 700,
          p: padding,
        }}
      >
        {error}
      </Typography>
    );
  }

  if (empty) {
    return (
      <Typography sx={{ fontFamily: "Montserrat", fontSize, p: padding }}>
        {emptyText}
      </Typography>
    );
  }

  return null;
};

export default StatusLine;
